exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#registerForm .vs-input--label[data-v-3612b92d]{text-transform:capitalize}", ""]);

// exports
